import React, { useState } from 'react';
import { string } from 'prop-types';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { Button, Input } from '@fiverr-private/fit';
import { URI } from '@fiverr-private/futile';
import { makersExperience } from '@fiverr-private/logo_maker_analytics/dist/esm/mixpanel';
import { sendBiEventWithPosition } from '../../../../shared/utils/sendBiEventWithPosition';
import { GET_STARTED_CTA_POSITIONS } from '../../../../shared/constants';
import { EVENT_TYPES } from '../../../../service/bigquery';
import { INNER_CLASSES } from '../constants';
import { INTEGRATIONS_MAP } from '../../constants';
import { getStartedUrl } from '../../../../shared/constants/urls';
import './style.scss';

const { reportGetStartedSubmitted } = makersExperience.integrationLandingPage;

const StartDesigning = ({ integration }) => {
    const [brandName, setBrandName] = useState('');
    const onBrandNameChange = ({ target: { value } }) => setBrandName(value);
    const onBrandNameSubmit = () => {
        sendBiEventWithPosition(
            GET_STARTED_CTA_POSITIONS.BOTTOM,
            EVENT_TYPES.GET_STARTED_BUYER_CLICKED
        );
        reportGetStartedSubmitted({
            elementPosition: GET_STARTED_CTA_POSITIONS.BOTTOM,
            brandName: brandName.trim(),
        });

        window.location = new URI(getStartedUrl())
            .addParams({
                source: INTEGRATIONS_MAP[integration]?.APP_NAME,
                get_started_brand_name: brandName,
            })
            .toString();
    };

    return (
        <div className="start-designing">
            <div className={INNER_CLASSES}>
                <h2>
                    <I18n k="makers_experience_perseus.general.fiverr_logo_maker" />
                </h2>
                <p>
                    <I18n k="makers_experience_perseus.buyer_landing_page.start_designing.tagline" />
                </p>
                <div className="cta-wrapper">
                    <Input
                        className="start-designing-input-wrapper"
                        inputClassName="start-designing-input"
                        placeholder={translate(
                            'makers_experience_perseus.buyer_landing_page.header.input_placeholder'
                        )}
                        name="get_started_brand_name"
                        aria-label={translate(
                            'makers_experience_perseus.buyer_landing_page.header.input_placeholder'
                        )}
                        autoComplete="off"
                        onChange={onBrandNameChange}
                        data-lpignore="true"
                    />
                    <Button
                        className="start-designing-btn"
                        color={Button.COLORS.BLUE}
                        fill={Button.FILLS.GHOST}
                        onClick={onBrandNameSubmit}
                    >
                        <I18n k="makers_experience_perseus.general.start_now" />
                    </Button>
                </div>
            </div>
        </div>
    );
};

StartDesigning.propTypes = {
    integration: string,
};

export default StartDesigning;
